import React, { PureComponent } from "react"
import { connect } from "react-redux"
import Button from "@mui/material/Button"
import CloseIcon from "@mui/icons-material/Close"
import IconButton from "@mui/material/IconButton"
import withStyles from "@mui/styles/withStyles"
import {
    showAllergensClassificationsIngredients,
    showSingleAllergenClassificationsIngredientsEdit
} from "../../../../../actions/Ingredients/Classifications/Allergens/Allergens"
import {
    getAllergenIngredient
} from "../../../../../reducers/Ingredients/Classifications/AllergensIngredients"

const styles = {
    container: {
        padding: 20
    },
    closeWindow: {
        textAlign: "right"
    },
    subContainer: {
        marginLeft: 15,
        marginBottom: 15,
        width: 200
    },
    titleLabelContainer: {
        fontSize: "1rem",
        transform: "matrix(0.75, 0, 0, 0.75, 0, 1.5 )",
        opacity: "0.54",
        transformOrigin: "0px 0px"
    },
    editBtn: {
        textAlign: "right",
        marginRight: 15
    }
}

export class AllergenIngredientRead extends PureComponent {

    _onClose = () => {
        const { showAllergensClassificationsIngredients } = this.props
        showAllergensClassificationsIngredients()
    }

    _onEditClick = () => {
        const {
            showSingleAllergenClassificationsIngredientsEdit,
            allergenIngredient
        } = this.props

        showSingleAllergenClassificationsIngredientsEdit(allergenIngredient.objectId, "edit")
    }

    render() {
        const {
            classes,
            allergenIngredient
        } = this.props

        return (
            <div className={classes.container}>
                <div className={classes.closeWindow}>
                    <IconButton aria-label="Fermer" onClick={this._onClose} size="large">
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={classes.subContainer}>
                    <div className={classes.titleLabelContainer}>
                        Nom
                    </div>
                    <div>
                        {allergenIngredient && allergenIngredient.name}
                    </div>
                </div>
                <div className={classes.editBtn}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this._onEditClick}
                    >
                        Editer
                    </Button>
                </div>
            </div>
        )
    }
}

const StyledAllergenIngredientRead = withStyles(styles)(AllergenIngredientRead)

export default connect((state, props) => {
    const { params: { id } } = props
    const allergenIngredient = id ? getAllergenIngredient(state, id) : null
    return {
        allergenIngredient: allergenIngredient
    }
}, {
    showAllergensClassificationsIngredients,
    showSingleAllergenClassificationsIngredientsEdit
})(StyledAllergenIngredientRead)
